import { Component, OnInit, OnDestroy } from '@angular/core';
import { SubSink } from 'subsink';
import { LoginService } from 'src/app/login/services/login-service.service';

@Component({
  selector: 'app-reset-my-password',
  templateUrl: './reset-my-password.component.html',
  styleUrls: ['./reset-my-password.component.scss']
})
export class ResetMyPasswordComponent implements OnInit, OnDestroy {
  private subs = new SubSink();

  password: string;
  passwordConfirm: string;

  passwordChanged = false;
  passwordFailed = false;

  constructor(private loginService: LoginService) {}
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
  resetState() {
    this.passwordChanged = false;
    this.passwordFailed = false;
  }

  ngOnInit() {
    this.resetState();
  }

  changePassword() {
    this.subs.add(
      this.loginService.resetMyPassword(this.password).subscribe(
        value => {
          this.resetState();
          console.log('Password Changed');
          this.passwordChanged = true;
        },
        error => {
          this.resetState();
          console.log('Password Failed');
          this.passwordFailed = true;
        }
      )
    );
  }
}
